import React from "react";
import { InformationCircleIcon } from "@heroicons/react/outline";

const Contributors = ({ guide, contributors }) => {
  return (
    <>
      <div className="bg-[#F4EEFF] w-64 h-full rounded-2xl p-5">
        <div>
          <h1 className="text-left text-2xl font-semibold mb-2">TY CSA 1</h1>
          <div className="flex flex-col items-center">
            <div className=" flex w-48 border-t border-gray-400"></div>
          </div>
        </div>
        <div className="flex flex-col bg-[#F4EEFF] mt-2 mb-2">
          <h1 className="text-[#4848A4] text-2xl font-semibold text-left mb-2">
            Guide
          </h1>
          <h1 className="text-[#747474]">Prof. Ashwini Shingare</h1>
        </div>
        <div>
          <h1 className="text-[#4848A4] text-2xl font-semibold text-left my-2">
            Contributors
          </h1>

          {/* <div className="flex flex-col">
            {contributors.map((contributor, index) => {
              <div className="flex flex-row place-items-center">
                <h1 className="mr-2 text-[#747474]">Anubhav Pabby</h1>
                <InformationCircleIcon
                  className="text-[#C2C2C2] h-5 w-5"
                  aria-hidden="true"
                />
              </div>;
            })}
          </div> */}

          <div className="flex flex-col">
            <div className="flex flex-row place-items-center">
              <h1 className="mr-2 text-[#747474]">Anjali Asolkar</h1>
              <InformationCircleIcon
                className="text-[#C2C2C2] h-5 w-5"
                aria-hidden="true"
              />
            </div>
            <div className="flex flex-row place-items-center">
              <h1 className="mr-2 text-[#747474]">Avinash Vijaywargiya</h1>
              <InformationCircleIcon
                className="text-[#C2C2C2] h-5 w-5"
                aria-hidden="true"
              />
            </div>
            <div className="flex flex-row place-items-center">
              <h1 className="mr-2 text-[#747474]">Aditya Sood</h1>
              <InformationCircleIcon
                className="text-[#C2C2C2] h-5 w-5"
                aria-hidden="true"
              />
            </div>
            <div className="flex flex-row place-items-center">
              <h1 className="mr-2 text-[#747474]">Ayush Prasad</h1>
              <InformationCircleIcon
                className="text-[#C2C2C2] h-5 w-5"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Contributors;
